import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2.5),
    overflowX: 'hidden',

    '&::after': {
      display: 'block',
      left: 0,
      bottom: 0,
      content: '""',
      position: 'absolute',
      borderTop: '50px solid transparent',
      borderRight: `100vw solid ${theme.palette.common.white}`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.common.white,

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      marginTop: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      textAlign: 'left',

      '& img': {
        marginTop: 0,
      },
    },
  },
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: '90%',
    marginTop: theme.spacing(4),
    borderRadius: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      width: 650,
      marginTop: 0,
      zIndex: 2,
    },
  },
  titleGraphical: {
    fontSize: 34,
    fontWeight: 'bold',
    fontFamily: 'Lato',
  },
  optionsHeader: {
    fontSize: 18,
    '& img': {
      paddingRight: 13,
    },
  },
}));
